// src/pages/Projects.js
import React from "react";
import styled from "styled-components";
import { FaAndroid, FaApple, FaGlobe } from "react-icons/fa";
import { gradients } from "../theme/theme";

/* --- Styled Components --- */
const ProjectsSection = styled.section`
  min-height: 100vh;
  padding: 4rem 2rem;
  background: ${gradients.heroBackground};
  color: white;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  background: linear-gradient(90deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: auto;
`;

const Card = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.05),
    rgba(255, 255, 255, 0.02)
  );
  padding: 2rem;
  border-radius: 16px;
  backdrop-filter: blur(12px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.7);
  }
`;

const ProjectTitle = styled.h3`
  font-size: 1.5rem;
  color: #00d4ff;
`;

const ProjectDesc = styled.p`
  font-size: 1rem;
  margin: 1rem 0;
  color: #ccc;
  line-height: 1.6;
`;

const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
`;

const StoreButton = styled.a`
  flex: 1;
  padding: 0.6rem 1rem;
  border-radius: 10px;
  background: #00d4ff;
  color: #121212;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-decoration: none;
  transition: all 0.3s;

  &:hover {
    background: #ff0066;
    color: white;
  }
`;
const DisabledButton = styled.div`
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background: #333;
  color: #888;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: not-allowed;
  opacity: 0.6;
`;

/* --- Projects Data --- */
const projectData = [
  {
    title: "DealDome - Classified App",
    description:
      "A modern classified app for buying & selling products with filters, real-time chat, and secure payments.",
    website: "https://dealdome.com/",
    android:
      "https://play.google.com/store/apps/details?id=com.dealdome&hl=en_IN",
    ios: "https://apps.apple.com/in/app/dealdome/id6743176110",
  },
  {
    title: "Cinystore",
    description:
      "Cinystore, is the ultimate social media app for film enthusiasts! Producers can now seamlessly share their latest movie information directly with their audience through our platform.",
    website: null, // ❌ no website
    android: null, // ❌ no Android
    ios: "https://apps.apple.com/in/app/cinystore/id6473719567",
  },
  {
    title: "HiresGulf - Jobs Portal",
    description:
      "Mobile-first job portal connecting Gulf employers with skilled professionals.",
    website: null, // ❌ no website
    android:
      "https://play.google.com/store/apps/details?id=com.horizoncandidateapp&hl=en_IN",
    ios: "https://apps.apple.com/ae/app/hiresgulf/id1532042887",
  },
  {
    title: "Buy & Sell (In Progress)",
    description:
      "Peer-to-peer marketplace app with real-time deals, offers, and secure transactions.",
    website: "#",
    android: "#",
    ios: "#",
    disabled: true, // 🚧 mark as disabled
  },
];

export default function Projects() {
  return (
    <ProjectsSection>
      <SectionTitle>🚀 Our Projects</SectionTitle>
      <Grid>
        {projectData.map((proj, i) => (
          <Card key={i}>
            <div>
              <ProjectTitle>{proj.title}</ProjectTitle>
              <ProjectDesc>{proj.description}</ProjectDesc>
            </div>
            <Links>
              {proj.website &&
                (proj.disabled ? (
                  <DisabledButton>🌐 Website</DisabledButton>
                ) : (
                  <StoreButton href={proj.website} target="_blank">
                    🌐 Website
                  </StoreButton>
                ))}

              {proj.android &&
                (proj.disabled ? (
                  <DisabledButton>
                    <FaAndroid /> Android
                  </DisabledButton>
                ) : (
                  <StoreButton href={proj.android} target="_blank">
                    <FaAndroid /> Android
                  </StoreButton>
                ))}

              {proj.ios &&
                (proj.disabled ? (
                  <DisabledButton>
                    <FaApple /> iOS
                  </DisabledButton>
                ) : (
                  <StoreButton href={proj.ios} target="_blank">
                    <FaApple /> iOS
                  </StoreButton>
                ))}
            </Links>
          </Card>
        ))}
      </Grid>
    </ProjectsSection>
  );
}
